module.exports = __webpack_public_path__ + "img/ceo_way_skill_04.d9bdee86.png";